/**
 * PaywallModal — affiché lorsqu'un utilisateur FREE dont l'essai a expiré
 * tente d'accéder au Scanner IA, à la génération de plans IA ou au Coach YUMIX.
 *
 * Le composant est purement présentationnel ; le contrôle d'accès est fait
 * en backend (`require_active_access`). Les composants appelants gèrent le
 * 402 et déclenchent ce modal.
 */
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { Lock, Sparkles, MessageCircle, Camera, Dumbbell } from 'lucide-react';

const PaywallModal = ({ open, onClose, reason, daysRemaining = 0, onContactCoach }) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-card border-orange-500/40 max-w-md" data-testid="paywall-modal">
        <DialogHeader>
          <div className="flex items-center justify-center w-16 h-16 mx-auto mb-3 rounded-full bg-orange-500/20 border-2 border-orange-500/40">
            <Lock className="w-8 h-8 text-orange-400" />
          </div>
          <DialogTitle className="text-center font-heading text-2xl uppercase tracking-tight" data-testid="paywall-title">
            Accès Premium requis
          </DialogTitle>
          <DialogDescription className="text-center text-sm leading-relaxed pt-2">
            {reason || (
              <>
                Ta période d'essai gratuite est terminée. Pour continuer avec le Coach et le Scanner IA,
                active ton accès Premium ou contacte ton coach.
              </>
            )}
          </DialogDescription>
        </DialogHeader>

        <div className="mt-4 space-y-3">
          <div className="flex items-center gap-3 p-3 rounded-lg bg-secondary/40 border border-border">
            <Camera className="w-5 h-5 text-orange-400 shrink-0" />
            <span className="text-sm">Scanner IA des repas (illimité)</span>
          </div>
          <div className="flex items-center gap-3 p-3 rounded-lg bg-secondary/40 border border-border">
            <Dumbbell className="w-5 h-5 text-orange-400 shrink-0" />
            <span className="text-sm">Génération de plans personnalisés</span>
          </div>
          <div className="flex items-center gap-3 p-3 rounded-lg bg-secondary/40 border border-border">
            <MessageCircle className="w-5 h-5 text-orange-400 shrink-0" />
            <span className="text-sm">Coach YUMIX disponible 24/7</span>
          </div>
        </div>

        <div className="mt-6 flex flex-col gap-2">
          <Button
            onClick={onContactCoach}
            className="bg-orange-500 hover:bg-orange-600 text-white font-bold"
            data-testid="paywall-contact-coach-btn"
          >
            <Sparkles className="w-4 h-4 mr-2" />
            Contacter mon coach
          </Button>
          <Button
            variant="outline"
            onClick={onClose}
            data-testid="paywall-close-btn"
          >
            Plus tard
          </Button>
        </div>

        {daysRemaining > 0 && (
          <p className="text-center text-xs text-muted-foreground mt-2">
            Il te reste {daysRemaining} jour{daysRemaining > 1 ? 's' : ''} d'essai gratuit.
          </p>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default PaywallModal;
